import { render, staticRenderFns } from "./EditLanguageDialog.vue?vue&type=template&id=4753209e&"
import script from "./EditLanguageDialog.vue?vue&type=script&lang=js&"
export * from "./EditLanguageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports